// The kHTMLMultiSelect stylesheet - pure style data, moved verbatim out of kHTMLMultiSelect.ts
// (kHTMLMultiSelect._Css) in the 2026-10-20 size split. kHTMLMultiSelect._Css is assigned this value.
export const kHTMLMultiSelectCss: string = `
                .kMultiChoicOptionTable{
                    border-collapse:collapse;
                    width:100%;
                    overflow:hidden;
                    cursor:pointer;
                    user-select:none;
                }
                .kMultiChoicOptionTable:hover{
                    background:rgba(123,97,255,0.08);
                    color:#1A1F2E;
                }
                .kMultiChoicOptionTable td{
                    border:none;
                    padding:0;
                }
                .multiselect-dropdown{
                    display:inline-flex;
                    flex-wrap:wrap;
                    align-items:center;
                    align-content:center;
                    gap:3px 5px;
                    padding:3px 28px 3px 8px;
                    border-radius:10px;
                    border:1px solid #E2E5EC;
                    background-color:#fff;
                    position:relative;
                    font-family:inherit;
                    font-size:13px;
                    color:#1A1F2E;
                    min-height:34px;
                    background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%235E6782' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
                    background-repeat:no-repeat;
                    background-size:12px 10px;
                    background-position:right 10px center;
                    transition:border-color 180ms;
                    cursor:pointer;
                }
                .multiselect-dropdown:hover{
                    border-color:#7B61FF;
                }
                /* NO FLOAT. A float computes 'display' to 'block', which silently discarded the
                 * inline-block below and left every child (icon and remove glyph) sitting on the
                 * TEXT BASELINE instead of the pill's centre line - measured at -1.5px for the
                 * icon and -3.5px for the glyph. Flex is what makes align-items:center apply. */
                .multiselect-dropdown span.optext, .multiselect-dropdown span.placeholder{
                    padding:0;
                    border-radius:6px;
                    display:inline-flex;
                    align-items:center;
                }
                .multiselect-dropdown span.optext{
                    background:#F0ECFF;
                    color:#7B61FF;
                    padding:1px 7px;
                    font-size:12px;
                    line-height:16px;
                    font-weight:600;
                }
                .multiselect-dropdown span.optext .optdel{
                    display:inline-flex;
                    align-items:center;
                    justify-content:center;
                    width:13px;
                    height:13px;
                    margin:0 -3px 0 4px;
                    font-size:13px;
                    line-height:1;
                    border-radius:3px;
                    cursor:pointer;
                    color:#7B61FF;
                    opacity:0.45;
                    transition:opacity 150ms, background-color 150ms;
                }
                .multiselect-dropdown span.optext .optdel:hover{
                    opacity:1;
                    background-color:rgba(123,97,255,0.18);
                }
                .multiselect-dropdown span.placeholder{
                    color:#94A3B8;
                    font-size:13px;
                }
                .multiselect-dropdown-list-wrapper{
                    box-shadow:0 8px 24px rgba(0,0,0,0.12);
                    z-index:100;
                    padding:8px;
                    border-radius:10px;
                    border:1px solid #E2E5EC;
                    display:none;
                    margin:-1px;
                    position:absolute;
                    top:0;
                    left:0;
                    min-width:100%;
                    min-width:max(100%,280px);
                    background:#fff;
                }
                /* THE PROMOTED PANEL. Every declaration here undoes a UA [popover] default that
                   would otherwise fight the coordinates ShowInTopLayer sets inline:
                     inset:auto     the UA sets inset:0, so right/bottom would pin the panel to the
                                    opposite edges of the viewport while top/left came from us
                     width/height   the UA sets fit-content, which ignores our min-width
                     overflow       the UA sets auto, adding a second scrollbar around the list
                                    that already scrolls itself
                     border/padding the UA draws its own; ours are on the base class above
                   No z-index is needed or wanted: the top layer is above the whole document by
                   definition, which is the entire reason this path exists. */
                .multiselect-dropdown-list-wrapper[popover]{
                    inset:auto;
                    width:auto;
                    height:auto;
                    max-width:none;
                    max-height:none;
                    overflow:visible;
                    border:1px solid #E2E5EC;
                    padding:8px;
                    background:#fff;
                    color:inherit;
                }
                .multiselect-dropdown-list-wrapper[popover]::backdrop{
                    background:transparent;
                }
                .multiselect-dropdown-list-wrapper .multiselect-dropdown-search{
                    margin-bottom:8px;
                    border-radius:8px;
                    border:1px solid #E2E5EC;
                    padding:7px 12px;
                    font-size:13px;
                    font-family:inherit;
                    outline:none;
                    box-sizing:border-box;
                    transition:border-color 180ms;
                    color:#1A1F2E;
                }
                .multiselect-dropdown-list-wrapper .multiselect-dropdown-search:focus{
                    border-color:#7B61FF;
                }
                .multiselect-dropdown-list{
                    padding:2px;
                    height:15rem;
                    overflow-y:auto;
                    overflow-x:hidden;
                }
                .multiselect-dropdown-list::-webkit-scrollbar{
                    width:6px;
                }
                .multiselect-dropdown-list::-webkit-scrollbar-thumb{
                    background-color:rgba(123,97,255,0.25);
                    border-radius:3px;
                }
                .multiselect-dropdown-list div{
                    padding:5px 8px;
                    border-radius:6px;
                }
                .multiselect-dropdown-list input{
                    height:1.15em;
                    width:1.15em;
                    margin-right:0.35em;
                    accent-color:#7B61FF;
                    cursor:pointer;
                }
                .multiselect-dropdown-list div:hover{
                    background-color:rgba(123,97,255,0.06);
                }
                .multiselect-dropdown span.maxselected{width:100%;}
                .multiselect-dropdown-all-selector{
                    border-bottom:1px solid #E2E5EC;
                    padding:6px 8px;
                    margin-bottom:4px;
                }
                `;
